import React from 'react';
import { sendEvent } from 'shared/helpers/requests';
import styles from './FifthBlock.module.scss';
import { ReactComponent as QuestionsIcon } from '../../images/questions.svg';
import { ReactComponent as EggIcon } from '../../images/banner_egg.svg';
import { ReactComponent as ArrowIcon } from '../../images/arrow.svg';
import { ReactComponent as CheckIcon } from '../../images/check.svg';
import Boy from '../../images/boy.png';
import { BuyButton } from '../BuyButton';
import { PRICE } from '../../constants';

type Props = {
  isAfterBuy: boolean;
  goToPayment(): void;
};

export function FifthBlock({ isAfterBuy, goToPayment }: Props) {
  const onClickBuy = () => {
    sendEvent({
      eventType: 'click_buy',
      eventSource: 'pryamyye_efiry_kak_kopit',
      eventInfo: JSON.stringify({ place: 'bellow' }),
    });
    goToPayment();
  };

  return (
    <div className={styles.root}>
      <div className={styles.waveImg} />
      <div className={styles.waveImg} />
      <QuestionsIcon className={styles.questionIcon} />
      <div className={styles.content}>
        <div className={styles.contentWrapper}>
          <div className={styles.bottomWrapper}>
            <div className={styles.structureWrapper}>
              <p className={styles.structureTitle}>Структура эфира</p>
              <ul className={styles.list}>
                <li>&bull;&nbsp; Приветствие и&nbsp;знакомство</li>
                <li>&bull;&nbsp; Погружение в&nbsp;тему</li>
                <li>&bull;&nbsp; Объяснение темы</li>
                <li>&bull;&nbsp; Практические задания</li>
                <li>&bull;&nbsp; Обратная связь и&nbsp;выводы</li>
              </ul>
              <div className={styles.reward}>
                <p className={styles.rewardTitle}>награда</p>
                <p className={styles.rewardExp}>
                  +30 <EggIcon />
                </p>
              </div>
            </div>
            <div className={styles.buttonWrapper}>
              {isAfterBuy ? (
                <>
                  <p className={styles.afterBuyText}>
                    Доступ оформлен <CheckIcon />
                  </p>
                  <p className={styles.afterBuyText}>
                    Отправим ссылку на&nbsp;следующий эфир на&nbsp;email
                  </p>
                </>
              ) : (
                <>
                  <BuyButton onClick={onClickBuy} text="Оформить доступ" />
                  <p className={styles.buyPrice}>{PRICE.priceForLesson}&nbsp;₽&nbsp;/ занятие</p>
                </>
              )}
            </div>
          </div>
          <ArrowIcon className={styles.arrow} />
          <div className={styles.titleWrapper}>
            <h4 className={styles.title}>Частые вопросы</h4>
            <span className={styles.titleHighlight} />
            <ul className={styles.questionsList}>
              <li>
                <p className={styles.itemTitle}>Как проходит занятие?</p>
                <p className={styles.itemDescription}>
                  Ребенок подключается по&nbsp;специальной ссылке. Урок проходит в&nbsp;прямом эфире
                  и&nbsp;включает разминку, объяснение темы, практические задания и&nbsp;другие
                  активности.
                </p>
              </li>
              <li>
                <p className={styles.itemTitle}>Можно&nbsp;ли посмотреть занятие в&nbsp;записи?</p>
                <p className={styles.itemDescription}>
                  Да, после каждого эфира вам отправляется ссылка на запись&nbsp;&mdash; даже если
                  вы не смогли присутствовать.
                </p>
              </li>
              <li>
                <p className={styles.itemTitle}>Что я&nbsp;получаю после оплаты?</p>
                <p className={styles.itemDescription}>
                  Доступ ко&nbsp;всем новым эфирам и&nbsp;записям предыдущих месяцев, полезные
                  материалы.
                </p>
              </li>
              <li>
                <p className={styles.itemTitle}>Какое оборудование необходимо?</p>
                <p className={styles.itemDescription}>
                  Любое устройство&nbsp;&mdash; компьютер, телефон или планшет. Камера
                  и&nbsp;микрофон необязательны.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <img className={styles.boyImg} src={Boy} alt="Мальчик" />
      </div>
    </div>
  );
}
